import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=0f0e5620&scoped=true&"
import script from "./Header.vue?vue&type=script&lang=js&"
export * from "./Header.vue?vue&type=script&lang=js&"
import style0 from "./Header.vue?vue&type=style&index=0&id=0f0e5620&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../college-and-career-public/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0e5620",
  null
  
)

export default component.exports